export const USER_FILTER_FIELDS = ['id', 'fullname', 'avatar', 'email', 'role']

export const SELECT_DROPDOWN_MIN_HEIGHT = 100

export const SELECT_DROPDOWN_ROLE = 'listbox'

export const SELECT_OFFSET_MAIN_AXIS = 4

export const CLOSE_ON_ANCESTOR_SCROLL_USER = 'user'

export const CLOSE_ON_ANCESTOR_SCROLL_NEVER = 'never'

export const CLOSE_ON_ANCESTOR_SCROLL_ALWAYS = 'always'
